import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/auths/useAuthService';

export default function LoginCloud() {
  const { isAuthenticated, login } = useAuth();
  const [searchParams] = useSearchParams();
  const redirectPath = searchParams.get('redirect_to') || '/';
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate(redirectPath);
    }

    login({ redirectPath })
      .then(() => {
        navigate(redirectPath);
      })
      .catch((err) => {
        console.log('error on oidc login', err);
      });

    // Only check on page load, don't have to react to changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return <> </>;
}
